import { render, staticRenderFns } from "./trainingModulePageMultipleChoiceWithPictures.vue?vue&type=template&id=540acabd&scoped=true&"
import script from "./trainingModulePageMultipleChoiceWithPictures.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageMultipleChoiceWithPictures.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageMultipleChoiceWithPictures.vue?vue&type=style&index=0&id=540acabd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540acabd",
  null
  
)

export default component.exports